import { createRoot } from "react-dom/client";
import { App } from "./app";
import "./index.css";

// StrictMode is intentionally OFF — the masonry-engine NodeResolver clears
// node state on the StrictMode simulated unmount but its guarded init
// effect doesn't re-fire, so subsequent `setNodeState` calls throw. Revisit
// when the SDK ships a fix.
const container = document.getElementById("root");
const root = createRoot(container!);

root.render(<App />);
